module.exports = __webpack_public_path__ + "static/media/heineken.36130481.jpeg";